import React from 'react';
import {
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { ETaskStatus } from '../../enums/task-status.enum';

const StatusDropdown = ({ onStatusChange }) => {
  const statusList = [
    { label: 'To Do', value: ETaskStatus.TO_DO },
    { label: 'In Progress', value: ETaskStatus.IN_PROGRESS },
    { label: 'Completed', value: ETaskStatus.COMPLETED },
    { label: 'On Hold', value: ETaskStatus.ON_HOLD }
  ];

  const [selectedStatus, setSelectedStatus] = React.useState<string[]>([]);

  const handleChange = (event) => {
    const {
      target: { value }
    } = event;
    const newSelectedStatus = typeof value === 'string' ? value.split(',') : value;
    
    setSelectedStatus(newSelectedStatus);

    // Call the callback passed from the parent
    if (onStatusChange) {
      onStatusChange(newSelectedStatus);
    }
  };

  return (
    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          background: '#fff',
          borderRadius: '20%',
          marginRight: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '32px',
          height: '32px',
          border: '1px solid #bdc3c7',
          alignSelf: 'end'
        }}
      >
        <FilterAltIcon
          style={{
            color: '#667085',
            fontSize: '1rem'
          }}
        />
      </div>
      <FormControl fullWidth style={{ minWidth: '13rem' }}>
        <InputLabel style={{
                        fontSize: '12px'
                      }}>Status</InputLabel>
        <Select
          label="Status"
          placeholder='Status'
          multiple
          value={selectedStatus}
          onChange={handleChange}
          renderValue={(selected) =>
            selected
              .map(
                (value) =>
                  statusList.find((status) => status.value === value)?.label
              )
              .join(', ')
          }
          style={{
            fontSize: '12px',
            height: '2rem',
            marginTop: '0.5rem'
          }}
          displayEmpty
        >
          {statusList.map((status, i) => (
            <MenuItem key={i} value={status.value}>
              <Checkbox checked={selectedStatus.indexOf(status.value) > -1} />
              <ListItemText primary={status.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default StatusDropdown;
